// Базовые параметры
export const minLength =500; // 500
export const maxLength = 800;
export const allowedLangs = ["ru"];

// Простейшие частотные профили (в реальности можно сделать точнее)
export const freqProfiles: Record<string, Record<string, number>> = {
  ru: {
    а: 0.0732,
    б: 0.0158,
    в: 0.0315,
    г: 0.0151,
    д: 0.0244,
    е: 0.0624,
    ж: 0.009,
    з: 0.0111,
    и: 0.0473,
    к: 0.0281,
    л: 0.0426,
    м: 0.0278,
    н: 0.0612,
    о: 0.0958,
    п: 0.0253,
    р: 0.0321,
    с: 0.0414,
    т: 0.0402,
    у: 0.0256,
    ф: 0.0009,
    х: 0.0053,
    ц: 0.0028,
    ч: 0.009,
    ш: 0.0049,
    щ: 0.0025,
    ъ: 0,
    ы: 0.0198,
    ь: 0.0151,
    э: 0.0015,
    ю: 0.0053,
    я: 0.0136,
  },
  en: {
    a: 0.0607,
    b: 0.0146,
    c: 0.0217,
    d: 0.0329,
    e: 0.0973,
    f: 0.0171,
    g: 0.0134,
    h: 0.032,
    i: 0.0558,
    j: 0.0006,
    k: 0.0046,
    l: 0.0354,
    m: 0.0186,
    n: 0.0503,
    o: 0.0497,
    p: 0.0143,
    q: 0.0009,
    r: 0.0479,
    s: 0.0503,
    t: 0.0665,
    u: 0.0241,
    v: 0.0131,
    w: 0.0137,
    x: 0.0043,
    y: 0.0125,
    z: 0.0003,
  },
};

// Минимальный список матерных слов
export const badWords: Record<string, string[]> = {
  ru: ["блять", "сука", "хуй", "пизд", "еба", "муд", "ганд"],
  en: ["fuck", "shit", "bitch", "asshole", "bastard"],
};

export const getAllowedDiff = (len: number): number => {
  if (len < 50) return 0.15;
  if (len < 150) return 0.1;
  if (len < 400) return 0.08;
  return 0.06;
};

export const moderationErrors: Record<string, string> = {
  too_short:
    "Модератор: текст слишком короткий, добавьте больше контекста, минимум 20 слов и 500 знаков.",
  too_long: "Модератор: текст слишком длинный, сократите до 500 символов.",
  unsupported_language:
    "Модератор: собеседник говорит на русском языке, задавайте вопрос на нём",
  unrealistic_frequency:
    "Модератор: ошибка, текст выглядит как бессмысленный набор символов или случайных букв.",
  offensive_language:
    "Модератор: обнаружена ненормативная или оскорбительная лексика. Пожалуйста, переформулируйте вопрос.",
  too_few_spaces:
    "Модератор: ошибка, текст выглядит как слитный набор символов.",
  too_few_words:
    "Модератор: текст вопроса должен содержать не менее трёх слов.",
  unknown_error:
    "Модератор: произошла непредвиденная ошибка при анализе текста.",
};
